import { IToastState } from './index';
import { createSelector } from '@reduxjs/toolkit';

const getToastStates = (states: RootState) => states.toast;

export const selectToastList = createSelector(
  getToastStates,
  (data: IToastState) => data.data
);
